/**
 * Create routes in a laravelish way from a name and parameters
 *
 * @export
 * @class route
 */
export default function(name, params) {
  var routes = {
    'posts.index-json': '/json/posts/',
    'posts.show': '/posts/{post}',
  };

  var url = routes[name];

  if (params) {
    Object.entries(params).forEach(([param, val]) => {
      url = url.replace('{' + param + '}', val);
    }, this);
  }

  return url;
}
